;(function ($) {
  if (!$.uniqBase) {
    $.uniqBase = {};
  }

  $.uniqBase.copyToClipboard = function (el, options) {
    // To avoid scope issues, use 'base' instead of 'this'
    // to reference this class from internal events and functions.
    var base = this;

    // Access to jQuery and DOM versions of element
    base.$el = $(el);
    base.el = el;

    // Add a reverse reference to the DOM object
    base.$el.data('uniqBase.copyToClipboard', base);

    base.init = function () {

      base.options = $.extend({},
        $.uniqBase.copyToClipboard.defaultOptions, options);
      base.addElements();
    };
    base.init();
  };

  /**
   * @method addElements
   * @desc adds copy to clipboard button and click function
   */
  $.uniqBase.copyToClipboard.prototype.addElements = function () {
    var base = this;

    // send only once ga request
    base.isCopied = false;
    var button = $('<button class="' + base.options.buttonClassName + '"/>');
    button.append(base.options.defaultButton);
    base.$el.append(button);

    button.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      base.selectAndCopy(this.parentElement.querySelector(base.options.textContainer));
      button.empty().append(base.options.buttonSelected);

      if (typeof base.options.analyticsCallback === 'function') {
        if (!base.isCopied) {
          base.isCopied = true;
          base.options.analyticsCallback.call(this, base);
        }
      }
    });
  };

  /**
   * @method selectAndCopy
   * @desc selects the text and copied it to clipboard
   */
  $.uniqBase.copyToClipboard.prototype.selectAndCopy = function (textContainer) {
    var selection, range;

    //Select Text
    if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(textContainer);
      selection.removeAllRanges();
      selection.addRange(range);
    } else if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(textContainer);
      range.select();
    }

    //Copy selected Text to clipboard
    document.execCommand('copy');

    //remove text selection
    if (window.getSelection) {
      if (window.getSelection().empty) {  // Chrome
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges) {  // Firefox
        window.getSelection().removeAllRanges();
      }
    } else if (document.selection) {  // IE?
      document.selection.empty();
    }
  };


  $.uniqBase.copyToClipboard.defaultOptions = {
    'buttonClassName': 'coupon-code-box-button',
    'textContainer': 'p',
    'defaultButton':'<i class="fa fa-files-o" aria-hidden="true"></i>',
    'buttonSelected': '<i class="fa fa-check-square-o" aria-hidden="true"></i>'
  };

  $.fn.uniqBase_copyToClipboard = function
    (options) {
    return this.each(function () {
      (new $.uniqBase.copyToClipboard(this, options));
    });
  };

})(jQuery);
